module.exports = __webpack_public_path__ + "media/images/athletes/3570-4202fe806e77db60a94a5b59af897e45.png";